import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import userContext from "./shared/state/userContextState";

export default new Vuex.Store({
  getters: {
    rightDrawerState: state => state.rightDrawer,
    leftDrawerState: state => state.leftDrawer
  },
  modules: {
    userContext
  },
  state: {
    leftDrawer: false,
    rightDrawer: false
  },
  mutations: {
    CHANGE_LEFT_DRAWER(state, data) {
      state.leftDrawer = data;
    },
    CHANGE_RIGHT_DRAWER(state, data) {
      state.rightDrawer = data;
    }
  }
});
